<template>
    <div class="relative isolate overflow-hidden bg-gray-900 py-24 sm:py-32">
        <div class="mx-auto max-w-7xl px-6 lg:px-8">
            <div class="mx-auto max-w-2xl lg:mx-0">
                <h1 class="text-5xl font-semibold tracking-tight text-white sm:text-7xl">Ayudanos a mejorar nuestro ambiente</h1>
                <h1 class="mt-8 text-2xl font-semibold tracking-tight text-white sm:text-3xl">Reforestación:</h1>
                <p class="text-lg font-medium text-pretty text-gray-300 sm:text-xl/8">
                    Identifica áreas críticas y planifica proyectos de reforestación de manglares, 
                    involucrando a estudiantes y voluntarios.
                </p>
                
                <h1 class="mt-8 text-2xl font-semibold tracking-tight text-white sm:text-3xl">Restauración de Ecosistemas:</h1> 
                <p class="text-lg font-medium text-pretty text-gray-300 sm:text-xl/8">
                    Trabaja en la restauración de manglares degradados, implementando técnicas de restauración ecológica.
                </p>
                
                <h1 class="mt-8 text-2xl font-semibold tracking-tight text-white sm:text-3xl">Educación Ambiental Continua:</h1> 
                <p class="text-lg font-medium text-pretty text-gray-300 sm:text-xl/8">
                    Desarrolla un programa continuo de educación ambiental para diferentes grupos de la sociedad, 
                    incluyendo talleres y seminarios.
                </p>
            </div>
        </div>
        <video class="h-full w-full absolute inset-0 -z-10 size-full object-cover object-right md:object-center"  autoPlay muted loop >
            <source 
            src="assets/images/pachamamaobc_mangrove-tree-leaves.webm"  
            type="video/mp4" />
            Your browser does not support the video tag.
        </video>
    </div>
    
</template>